// Generated by Melange

import * as Buhta_cabinet__Btn from "../../html/Btn.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function IdentInitPanel(Props) {
  let onStart = Props.onStart;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("img", {
        className: "w-16 h-16",
        alt: "face",
        src: StaticAsset.src("/static/icons/face-gray-64.svg")
      }),
      JsxRuntime.jsx(Buhta_components__Text.H1.make, {
        className: "mt-6",
        children: "Подтвердите свою личность"
      }),
      JsxRuntime.jsx(Buhta_components__Text.P.make, {
        className: "text-asphalt-dark mt-2 text-center",
        children: "Идентификация нужна, чтобы мы точно знали, что это вы, а также для доступа к продуктам Бухты"
      }),
      JsxRuntime.jsx("hr", {
        className: "my-10 border-gray-main w-full"
      }),
      JsxRuntime.jsx(Buhta_components__Text.H4.make, {
        className: "w-full",
        children: "Как проходит идентификация:"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "w-8 h-8",
                    alt: "passport",
                    src: StaticAsset.src("/static/icons/scan-passport.svg")
                  }),
                  JsxRuntime.jsx("img", {
                    className: "w-8 h-8",
                    alt: "id",
                    src: StaticAsset.src("/static/icons/scan-id.svg")
                  }),
                  JsxRuntime.jsx("hr", {
                    className: "w-full border-gray-main"
                  })
                ],
                className: "flex gap-2 items-center"
              }),
              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                className: "text-asphalt mt-2",
                children: "Сканирование документа"
              })
            ],
            className: "grow"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "w-8 h-8",
                    alt: "face",
                    src: StaticAsset.src("/static/icons/scan-face.svg")
                  }),
                  JsxRuntime.jsx("hr", {
                    className: "w-full border-gray-main"
                  })
                ],
                className: "flex gap-2 items-center"
              }),
              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                className: "text-asphalt mt-2",
                children: "Сканирование лица"
              })
            ],
            className: "grow"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-8 h-8",
                alt: "check",
                src: StaticAsset.src("/static/icons/scan-check.svg")
              }),
              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                className: "text-asphalt mt-2",
                children: "Проверка"
              })
            ]
          })
        ],
        className: "w-full flex mt-4 gap-6"
      }),
      JsxRuntime.jsx(Buhta_components__Text.H4.make, {
        className: "w-full mt-10",
        children: "Для этого нужно:"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-5 h-5",
            alt: "check",
            src: StaticAsset.src("/static/icons/check-light-blue-20.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            children: "Подготовить оригинал удостоверения личности или паспорт"
          })
        ],
        className: "mt-4 flex gap-2 w-full"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-5 h-5",
            alt: "check",
            src: StaticAsset.src("/static/icons/check-light-blue-20.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            children: "Камера и хорошее освещение, чтобы отсканировать документы и лицо"
          })
        ],
        className: "mt-4 flex gap-2 w-full"
      }),
      JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
        title: "Начать идентификацию",
        onClick: onStart,
        className: "mt-10 py-2.5 w-full",
        text: /* He5 */ 1
      }),
      JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
        className: "mt-4 text-center",
        children: [
          "Нажимая на \"Начать идентификацию\", вы соглашаетесь с ",
          JsxRuntime.jsx("a", {
            children: "обработкой персональных данных",
            className: "text-links",
            href: "/kz/ru/legal/consent",
            target: "_blank"
          })
        ]
      })
    ],
    className: "bg-white shadow-kkm w-[684px] px-30 py-10 rounded-md mt-16 flex flex-col items-center"
  });
}

const make = IdentInitPanel;

export {
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
